import React, { useContext, useState } from 'react';
import { Row, Col, size } from '@everlywell/leaves';
import { generateKey } from 'utils/helpers';
import { animated as A, useSpring, config } from 'react-spring';

import { RefsForAnimationContext } from '../../../templates/enterprise';
import Container from '../Container';
import SectionTitle from '../SectionTitle';
import SectionDisplayText from '../SectionDisplayText';

import { useScrolledIntoViewOnce } from 'utils/hooks';

import * as S from './styles';

type ContentWithImage = {
  heading: string;
  description: string;
  imageSrc: string;
  imageAlt: string;
};

export interface ExperienceSectionProps {
  title: string;
  headline: string;
  listOfContent: ContentWithImage[];
}

export const ExperienceSection: React.FC<ExperienceSectionProps> = ({
  title,
  headline,
  listOfContent,
}) => {
  const [inView, setInView] = useState(false);

  const contentCardsEl = useScrolledIntoViewOnce(() => {
    setInView(true);
  });

  const { animation3, animation4 } = useContext(RefsForAnimationContext);

  // triggered from useChain in enterprise template
  const titleTransition = useSpring({
    from: { opacity: 0, transform: `translateY(${size.xl1}px)` },
    to: { opacity: 1, transform: 'translateY(0)' },
    ref: animation3,
    config: config.slow,
  });
  // triggered from useChain in enterprise template
  const displayTransition = useSpring({
    from: { opacity: 0, transform: `translateY(${size.xl2}px)` },
    to: { opacity: 1, transform: 'translateY(0)' },
    ref: animation4,
    config: config.slow,
  });
  // triggered from scrolling into view
  const cardsTransition = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0)' : `translateY(${size.xl3}px)`,
    config: config.slow,
  });

  return (
    <Container>
      <Row center="xs">
        <Col xs={12} lg={10}>
          {/* @ts-ignore */}
          <A.div style={titleTransition}>
            <SectionTitle text={title} />
          </A.div>
        </Col>
      </Row>
      <Row center="xs">
        <Col xs={12} lg={10}>
          {/* @ts-ignore */}
          <A.div style={displayTransition}>
            <SectionDisplayText text={headline} />
          </A.div>
        </Col>
      </Row>
      <Row center="xs" around="lg">
        <Col xs={10} sm={12} lg={10}>
          <S.InfoBlockContainer ref={contentCardsEl}>
            {listOfContent.length
              ? listOfContent.map(content => (
                  // @ts-ignore
                  <S.AnimatedBlockContainer style={cardsTransition}>
                    <S.InfoBlock
                      title={content.heading}
                      image={content.imageSrc}
                      imageAlt={content.imageAlt}
                      content={content.description}
                      size="large"
                      key={generateKey()}
                    />
                  </S.AnimatedBlockContainer>
                ))
              : null}
          </S.InfoBlockContainer>
        </Col>
      </Row>
    </Container>
  );
};

export default ExperienceSection;
